import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { FormattedMessage } from "react-intl";

export const dictionaryColorByStatus = {
    disabled: {
        color: "gray",
        component: (
            <TimelineDot style={{ backgroundColor: "#7D889B" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <circle cx="6" cy="6" r="6" fill="white" />
                </svg>
            </TimelineDot>
        ),
    },
    inProgress: {
        color: "orange",
        component: (
            <TimelineDot style={{ backgroundColor: "#EDB600" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <circle cx="6" cy="6" r="6" fill="white" />
                </svg>
            </TimelineDot>
        ),
    },
    success: {
        color: "#6BBE22",
        component: (
            <TimelineDot color="grey" className="bg-success border-success">
                <i className="fa fa-check text-white"></i>
            </TimelineDot>
        ),
    },
    error: {
        color: "#E11900",
        component: (
            <TimelineDot color="error">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="8" fill="white" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM9.70711 8.29289C9.31658 7.90237 8.68342 7.90237 8.29289 8.29289C7.90237 8.68342 7.90237 9.31658 8.29289 9.70711L10.5858 12L8.29289 14.2929C7.90237 14.6834 7.90237 15.3166 8.29289 15.7071C8.68342 16.0976 9.31658 16.0976 9.70711 15.7071L12 13.4142L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13.4142 12L15.7071 9.70711C16.0976 9.31658 16.0976 8.68342 15.7071 8.29289C15.3166 7.90237 14.6834 7.90237 14.2929 8.29289L12 10.5858L9.70711 8.29289Z"
                        fill="#E11900"
                    />
                </svg>
            </TimelineDot>
        ),
    },
};

const VerticalTimeline = ({ data }) => {
    const dataTimeline = [
        {
            step: "data_received",
            status: () => {
                if (data.status === "DISABLE" || data.status === "NOT_CREATED" || data.status === "INITIAL") {
                    return "inProgress";
                }
                if (
                    data.status === "PROCESS" ||
                    data.status === "PASS" ||
                    data.status === "REVIEW" ||
                    data.status === "SKIP" ||
                    data.status === "ERROR_KYC" ||
                    data.status === "REFUSED" ||
                    data.status === "REJECT"
                ) {
                    return "success";
                }
                return "disabled";
            },
        },
        {
            step: "data_validation",
            status: () => {
                if (data.status === "DISABLE" || data.status === "NOT_CREATED" || data.status === "INITIAL") {
                    return "disabled";
                }
                if (data.status === "PROCESS" || data.status === "SKIP") {
                    return "inProgress";
                }
                if (
                    data.status === "PASS" ||
                    data.status === "REVIEW" ||
                    data.status === "REFUSED" ||
                    data.status === "REJECT"
                ) {
                    return "success";
                }
                if (data.status === "ERROR_KYC") {
                    return "error";
                }
                return "disabled";
            },
        },
        {
            step: "approval_data",
            status: () => {
                if (
                    data.status === "DISABLE" ||
                    data.status === "NOT_CREATED" ||
                    data.status === "INITIAL" ||
                    data.status === "PROCESS" ||
                    data.status === "SKIP"
                ) {
                    return "disabled";
                }
                if (data.status === "REVIEW") {
                    return "inProgress";
                }
                if (data.status === "PASS") {
                    return "success";
                }
                if (data.status === "ERROR_KYC" || data.status === "REFUSED" || data.status === "REJECT") {
                    return "error";
                }
                return "disabled";
            },
        },
    ];

    return (
        <Timeline
            sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                },
            }}
        >
            {dataTimeline.map((item, key) => (
                <TimelineItem key={key}>
                    <TimelineSeparator>
                        {dictionaryColorByStatus[item.status()].component}
                        {key !== dataTimeline.length - 1 && (
                            <TimelineConnector
                                style={{
                                    backgroundColor: dictionaryColorByStatus[item.status()].color,
                                }}
                            />
                        )}
                    </TimelineSeparator>
                    <TimelineContent>
                        <span className="text-title-record">
                            <FormattedMessage id={item.step} defaultMessage={item.step} />
                        </span>
                    </TimelineContent>
                </TimelineItem>
            ))}
        </Timeline>
    );
};

export default VerticalTimeline;
